import * as Yup from 'yup';
import { errorMessages } from 'components/ui/formik-controls';

export const SignInSchema = Yup.object().shape({
  email: Yup.string().required(errorMessages.required),
  password: Yup.string().required(errorMessages.required),
});
